var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ticket
    ? _c("div", { staticClass: "request-detail-page show-scrollbar" }, [
        _c("header", { staticClass: "request-detail-header" }, [
          _c(
            "button",
            {
              staticClass: "request-back",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("cancel")
                }
              }
            },
            [
              _c("portal-icon", { attrs: { name: "arrow-left", size: 16 } }),
              _vm._v(" " + _vm._s(_vm.$t("requests.page-heading")) + " ")
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "request-title-row" },
            [
              _c("div", { staticClass: "request-title" }, [
                _c("span", { staticClass: "request-number" }, [
                  _vm._v(_vm._s(_vm.ticket.ticketNumber))
                ]),
                _c("h1", [_vm._v(_vm._s(_vm.ticket.subject))])
              ]),
              _vm.ticket.open
                ? _c(
                    "portal-status-pill",
                    {
                      attrs: {
                        background: _vm.ticketStatusBackground(
                          _vm.ticket,
                          _vm.ticketTypes
                        ),
                        color: "var(--portal-text)"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.ticket.status) + " ")]
                  )
                : _c(
                    "portal-status-pill",
                    {
                      attrs: {
                        background: "var(--v-alert_10-base)",
                        color: "var(--v-alert-base)"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("requests.closed")) + " ")]
                  )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "request-detail-grid" }, [
          _c("main", { staticClass: "request-conversation" }, [
            _c(
              "section",
              { staticClass: "comment-composer" },
              [
                _c(
                  "label",
                  {
                    staticClass: "composer-label",
                    attrs: { for: "request-comment" }
                  },
                  [_vm._v(_vm._s(_vm.$t("requests.comment")))]
                ),
                _c("v-textarea", {
                  attrs: {
                    id: "request-comment",
                    rows: "5",
                    dense: "",
                    outlined: "",
                    "persistent-placeholder": "",
                    "hide-details": ""
                  },
                  model: {
                    value: _vm.comment,
                    callback: function($$v) {
                      _vm.comment = $$v
                    },
                    expression: "comment"
                  }
                }),
                _c(
                  "div",
                  { staticClass: "composer-footer" },
                  [
                    _c("portal-file-input", {
                      staticClass: "composer-file-input",
                      attrs: {
                        label: _vm.$t("requests.attachments"),
                        placeholder: _vm.$t("requests.upload-attachments"),
                        "remove-label": _vm.$t("global.delete")
                      },
                      model: {
                        value: _vm.attachments,
                        callback: function($$v) {
                          _vm.attachments = $$v
                        },
                        expression: "attachments"
                      }
                    }),
                    _c(
                      "button",
                      {
                        staticClass: "add-comment-action",
                        attrs: { type: "button", disabled: !_vm.comment },
                        on: {
                          click: function($event) {
                            return _vm.addComment()
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("requests.add-comment")) + " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm.comments.length
              ? _c(
                  "section",
                  { staticClass: "comment-stream" },
                  _vm._l(_vm.comments, function(ticketComment) {
                    return _c(
                      "article",
                      { key: ticketComment.id, staticClass: "comment-card" },
                      [
                        _c("header", { staticClass: "comment-header" }, [
                          _c("span", { staticClass: "comment-avatar" }, [
                            _vm._v(
                              _vm._s(
                                _vm.commenterInitials(ticketComment.commentBy)
                              )
                            )
                          ]),
                          _c("div", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.getCommentBy(ticketComment.commentBy)
                                )
                              )
                            ]),
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.DateTime.fromISO(
                                      ticketComment.created
                                    ).toLocaleString(_vm.DateTime.DATETIME_FULL)
                                  ) +
                                  " "
                              )
                            ]),
                            ticketComment.updated
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("requests.existing.updated")
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.DateTime.fromISO(
                                          ticketComment.updated
                                        ).toLocaleString(
                                          _vm.DateTime.DATETIME_FULL
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        ticketComment.commentFormat === "PlainText"
                          ? _c("div", { staticClass: "comment-body" }, [
                              _vm._v(" " + _vm._s(ticketComment.comment) + " ")
                            ])
                          : _c("div", {
                              staticClass: "comment-body rich-comment",
                              domProps: {
                                innerHTML: _vm._s(ticketComment.comment)
                              }
                            }),
                        ticketComment.attachments &&
                        ticketComment.attachments.length
                          ? _c(
                              "div",
                              { staticClass: "comment-attachments" },
                              _vm._l(ticketComment.attachments, function(
                                attachment
                              ) {
                                return _c(
                                  "button",
                                  {
                                    key: attachment.fileName,
                                    staticClass: "comment-attachment",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.downloadFile(attachment)
                                      }
                                    }
                                  },
                                  [
                                    _c("portal-icon", {
                                      attrs: { name: "paperclip", size: 14 }
                                    }),
                                    _vm._v(
                                      " " + _vm._s(attachment.fileName) + " "
                                    )
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              : _vm._e()
          ]),
          _c("aside", { staticClass: "request-sidebar" }, [
            _c("section", { staticClass: "request-meta-card" }, [
              _c("div", { staticClass: "request-meta-row" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("requests.existing.requester")))
                ]),
                _vm.requester
                  ? _c("strong", [
                      _vm._v(
                        _vm._s(_vm.requester.firstName) +
                          " " +
                          _vm._s(_vm.requester.lastName)
                      )
                    ])
                  : _c("strong", [_vm._v("—")])
              ]),
              _c("div", { staticClass: "request-meta-row" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("requests.existing.type")))]),
                _c("strong", [_vm._v(_vm._s(_vm.ticketType.type || "—"))])
              ]),
              _c("div", { staticClass: "request-meta-row" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("requests.existing.created")))
                ]),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.DateTime.fromISO(_vm.ticket.created).toLocaleString(
                        _vm.DateTime.DATETIME_MED
                      )
                    )
                  )
                ])
              ]),
              _c("div", { staticClass: "request-meta-row" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("requests.existing.updated")))
                ]),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.DateTime.fromISO(_vm.ticket.updated).toLocaleString(
                        _vm.DateTime.DATETIME_MED
                      )
                    )
                  )
                ])
              ])
            ]),
            _vm.hasFormAnswers
              ? _c("section", { staticClass: "request-answer-section" }, [
                  _c(
                    "button",
                    {
                      staticClass: "request-answer-toggle",
                      attrs: {
                        type: "button",
                        "aria-expanded": _vm.showFormAnswers ? "true" : "false"
                      },
                      on: {
                        click: function($event) {
                          _vm.showFormAnswers = !_vm.showFormAnswers
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("requests.new.details")))
                      ]),
                      _c("span", { staticClass: "request-answer-count" }, [
                        _vm._v(_vm._s(_vm.ticket.formData.answers.length))
                      ]),
                      _c("portal-icon", {
                        attrs: {
                          name: _vm.showFormAnswers
                            ? "chevron-up"
                            : "chevron-down",
                          size: 17
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showFormAnswers,
                          expression: "showFormAnswers"
                        }
                      ],
                      staticClass: "request-answer-card"
                    },
                    _vm._l(_vm.ticket.formData.answers, function(
                      answer,
                      index
                    ) {
                      return _c(
                        "div",
                        { key: index, staticClass: "request-answer" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.questionText(answer.question)))
                          ]),
                          _c("strong", { staticClass: "text-pre-wrap" }, [
                            _vm._v(_vm._s(answer.answer))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e()
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }